import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DateUtilProvider } from '@starley/ion-directives';

@Component({
    selector: 'app-mm-data-filter',
    templateUrl: './mm-data-filter.component.html',
    styleUrls: ['./mm-data-filter.component.scss'],
})
export class MmDataFilterComponent {

    @Input() formFiltro: any = {};
    @Input() id: string = '';
    @Output() toEventDismiss: EventEmitter<any> = new EventEmitter();
    selectCalendarStartDate: any;
    selectCalendarEndDate: any;


    constructor(private dateUtilProvider: DateUtilProvider) {

        console.log(this.formFiltro, this.id);
    }


    /**
   * Determines whether valid date is
   * @author Starley Cazorla
   * @returns true if valid date 
   */
    checkDate(inputDate: string): boolean {
        if (inputDate.length === 10) {
            let isValid = this.dateUtilProvider.isValidDate(inputDate);
            return isValid;
        }
        return false;
    }

    isValidDateInitialDate(): boolean {
        return this.checkDate(this.formFiltro.dataInicio);
    }

    isValidDateFimDate(): boolean {
        return this.checkDate(this.formFiltro.dataFim);
    }

    isDataInferior(): boolean {
        return this.dateUtilProvider.firstBiggerThanSecond(this.formFiltro.dataInicio, this.formFiltro.dataFim);
    }

    updateData() {
        if (this.isValidDateInitialDate() && this.isValidDateFimDate()) {
            this.toEventDismiss.emit(this.formFiltro);
        }
    }

    touchSetStartDate() {
        this.formFiltro.dataInicio = this.selectCalendarStartDate.substring(0, 10).split('-').reverse().join('/');
        this.isValidDateInitialDate();
        this.updateData()
    }

    touchSetFinalDate() {
        this.formFiltro.dataFim = this.selectCalendarEndDate.substring(0, 10).split('-').reverse().join('/');
        this.isValidDateFimDate();
        this.updateData()
    }
}
